module.exports = __webpack_public_path__ + "static/media/173.dbd29ff5.mp3";